exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding-top[_v-219f76b2]{padding-top:20px}.gray[_v-219f76b2]{background-color:hsla(0,0%,75%,.2)!important;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-219f76b2&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/forms/DelayedMessageForm.vue
// module id = 297
// module chunks = 0